import { Plus, Blocks, FileSpreadsheet, Sparkles } from "lucide-react";
import { exportAssetsToCSV } from "@/utils/exportUtils";
import { toast } from "sonner";
import type { UnifiedAsset } from "@/hooks/useAssetsUnified";
import { ComboButton } from "@/components/ui/ComboButton";

interface AssetsActionButtonProps {
  onAddAsset: () => void;
  assets?: UnifiedAsset[];
  onBuildPortfolio?: () => void;
  onAiImport?: () => void;
}

export function AssetsActionButton({ onAddAsset, assets = [], onBuildPortfolio, onAiImport }: AssetsActionButtonProps) {
  const handleBuildPortfolio = () => {
    onBuildPortfolio?.();
  };

  const handleExportToExcel = () => {
    if (assets.length === 0) {
      toast.error('No assets available for export');
      return;
    }
    
    try {
      exportAssetsToCSV(assets);
      toast.success(`Successfully exported ${assets.length} assets to Excel`);
    } catch (error) {
      console.error('Error exporting assets:', error);
      toast.error('Failed to export assets. Please try again.');
    }
  };

  return (
    <ComboButton
      label="Add Asset"
      icon={<Plus className="h-4 w-4" />}
      onPrimaryClick={onAddAsset}
      size="sm"
      variant="default"
      menuItems={[
        { label: "Build Portfolio", onClick: handleBuildPortfolio, icon: <Blocks className="h-4 w-4" /> },
        { label: "Ai-Import Data", onClick: () => { onAiImport?.(); }, icon: <Sparkles className="h-4 w-4" /> },
        { label: "Export to Excel", onClick: handleExportToExcel, icon: <FileSpreadsheet className="h-4 w-4" />, disabled: assets.length === 0 },
      ]}
    />
  );
}
